"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const auth0_react_1 = require("@auth0/auth0-react");
const apiUtils_1 = require("../util/apiUtils");
const auth_1 = require("../util/auth");
const requestSealTransaction = async (transactionId, getAuthHeader, getAccessTokenSilently, loginWithRedirect) => {
    const accessToken = await (0, auth_1.getAccessToken)(getAccessTokenSilently);
    const response = await fetch(`${(0, apiUtils_1.getAPIUrl)()}admin/transaction.seal?id=${encodeURIComponent(String(transactionId))}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...getAuthHeader(accessToken),
        },
    });
    if (!response.ok) {
        let errorMessage = `HTTP ${response.status}`;
        let errorJson;
        try {
            if (response.headers.get("content-type")?.includes("application/json")) {
                errorJson = await response.json();
                errorMessage = errorJson?.error || errorJson?.message || errorMessage;
                if (Array.isArray(errorJson?.violations) &&
                    errorJson.violations.length) {
                    errorMessage = `${errorMessage}: ${errorJson.violations.join("; ")}`;
                }
                if (errorJson?.trace_id) {
                    errorMessage = `${errorMessage} (trace_id: ${errorJson.trace_id})`;
                }
            }
            else {
                const errorText = await response.text();
                errorMessage = errorText.slice(0, 1000) || errorMessage;
            }
        }
        catch {
            /* ignore parse errors */
        }
        const error = new Error(errorMessage);
        error.status = response.status;
        if ((0, auth_1.shouldTriggerLoginRedirect)(error, response.status)) {
            loginWithRedirect();
        }
        throw error;
    }
};
const useSealTransaction = () => {
    const { getAuthHeader, getAccessTokenSilently } = (0, auth_1.useAuthentication)();
    const { loginWithRedirect } = (0, auth0_react_1.useAuth0)();
    const [state, setState] = (0, react_1.useState)({
        status: apiUtils_1.LoaderStatus.Idle,
        error: null,
    });
    const resetSealState = (0, react_1.useCallback)(() => {
        setState({ status: apiUtils_1.LoaderStatus.Idle, error: null });
    }, []);
    const sealTransaction = (0, react_1.useCallback)(async (transactionId) => {
        setState({ status: apiUtils_1.LoaderStatus.Loading, error: null });
        try {
            await requestSealTransaction(transactionId, getAuthHeader, getAccessTokenSilently, loginWithRedirect);
            setState({ status: apiUtils_1.LoaderStatus.Success, error: null });
        }
        catch (error) {
            if ((0, auth_1.shouldTriggerLoginRedirect)(error, error?.status)) {
                loginWithRedirect();
            }
            setState({
                status: apiUtils_1.LoaderStatus.Error,
                error: error?.message || "Failed to seal transaction. Please try again.",
            });
            throw error;
        }
    }, [getAuthHeader, getAccessTokenSilently, loginWithRedirect]);
    return {
        sealStatus: state.status,
        sealError: state.error,
        sealTransaction,
        resetSealState,
    };
};
exports.default = useSealTransaction;
